import { FrameBody,Error,ErrorProps } from "@npd-ng/adp-benchmark";
import errorIcon from '../assets/error_icon.svg';
export default function ErrorLoadinfView() {
 const deviceReadiness = {
    "title": "Error - System Error",
    "code": "000",
    "message": "An error has been encountered and the application has stopped working. <br/>Please <strong>exit the application</strong> and try again.<br/>If problems persist, please contact the NAEP Help Desk"
 }
  const errorProps: ErrorProps = {
    error:{
      iconSrc: errorIcon,
      title: deviceReadiness.title,
      message: deviceReadiness.message,
      buttons:[{
          label: "Exit Application",
          action:()=>{window.close()},
          variant: "secondary"
      }]}
    }
  return (
    <>
       <FrameBody>
          <Error {...errorProps}/>
       </FrameBody>

    </>
  )
}
